<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="atlasti-logo">
    <path
      d="M24 14.811V12c0-.462-.042-.923-.084-1.385C23.245 4.657 18.168 0 12 0S.755 4.657.084 10.615C.042 11.077 0 11.538 0 12c0 6.63 5.37 12 12 12h9.986c1.09 0 2.014-.881 2.014-2.014 0-1.09-.881-1.972-1.972-2.014h-1.72c-2.476 0-4.322-1.762-4.322-4.406v-3.608c0-.461-.084-.923-.252-1.385A3.95 3.95 0 0012 7.93a3.95 3.95 0 00-3.734 2.643c-.168.42-.252.882-.252 1.385A3.984 3.984 0 0012 15.944a1.97 1.97 0 011.972 1.804v.378c-.084 1.007-.965 1.804-1.972 1.804-4.406 0-8.014-3.608-8.014-8.014 0-.461.042-.923.126-1.385C4.783 6.755 8.056 3.902 12 3.902s7.217 2.853 7.888 6.63c.084.461.126.88.126 1.384v2.811c0 1.091.881 2.014 2.014 2.014 1.09.042 1.972-.839 1.972-1.93"
    />
  </svg>
</template>

<style lang="scss">
.atlasti-logo {
  display: block;
  width: 100%;
  height: auto;
  fill: #e41319;
}
</style>
